module.exports = __webpack_public_path__ + "static/kinnexus-5403a9c021e33d644d7972b1b09c3fc6.jpg";